<template>
	<div>
		<Loader :show="loading"></Loader>

		<FormulateForm ref="form" v-model="registerForm" @submit="register">
			<FormulateInput :label="$t('name')" name="name" :validation-name="$t('name')" validation="required" />

			<FormulateInput
				:label="$t('lastname')"
				name="lastname"
				:validation-name="$t('lastname')"
				validation="required"
			/>

			<FormulateInput
				type="date"
				name="birthdate"
				validation-name="Fecha de nacimiento"
				label="Fecha de nacimiento"
				validation="required"
				:splitted="true"
			/>

			<FormulateInput
				label="Documento de identidad"
				type="identification"
				name="document"
				validation-name="Documento de identidad"
				validation="bail|required|documentID"
			/>

			<FormulateInput
				:label="$t('email')"
				type="email"
				name="email"
				:validation-name="$t('email')"
				validation="required|email"
			/>
			<FormulateInput
				:label="$t('password')"
				type="password"
				name="password"
				:validation-name="$t('password')"
				validation="required"
			/>
			<FormulateInput
				:label="$t('passwordConfirm')"
				type="password"
				name="password_confirm"
				validation="bail|required|confirm"
				:validation-name="$t('passwordConfirm')"
			/>

			<FormulateInput
				:label="$t('phone')"
				type="phone"
				name="phone"
				:validation-name="$t('phone')"
				validation="optional|^phone"
			/>

			<div class="alert alert-conditions">
				Al continuar, aceptas los <span class="text-primary">términos y condiciones de uso</span> y la
				<span class="text-primary">política de privacidad</span> de CobraTicket.
			</div>

			<div class="d-flex justify-content-end mt-3">
				<button class="btn btn-primary btn-block btn-lg" type="submit" :disabled="procesing">
					<span v-if="procesing">{{ $t("saving") }} <span class="btn-loader"/></span>
					<span v-if="!procesing">{{ $t("button") }}</span>
				</button>
			</div>
		</FormulateForm>

		<!-- <div class="or mt-4 mb-4"></div> -->

		<!-- <div> -->
		<!-- <AuthFacebook />

			<GoogleAuth /> -->
		<!-- </div> -->
	</div>
</template>

<script>
import gql from "graphql-tag"

// import GoogleAuth from "./GoogleAuth"
// import AuthFacebook from "./AuthFacebook"
import { onLogin } from "@/vue-apollo"
import Loader from "@/components/Loader"

export default {
	name: "Register",
	components: {
		Loader
		// GoogleAuth,
		// AuthFacebook
	},
	props: ["redirectTo"],
	data() {
		return {
			loading: false,
			procesing: false,
			registerForm: {
				name: "",
				lastname: "",
				email: "",
				document: { number: null, type: "UY" },
				birthdate: null,
				password: "",
				passwordConfirm: ""
			}
		}
	},

	mounted() {
		console.log("register mounted")
	},

	methods: {
		// loginFacebook(user) {
		// 	if (user.status == 'connected' && user.authResponse) {
		// 		const fToken = user.authResponse.accessToken
		// 		const userId = user.authResponse.userID

		// 		if (!this.loginIn && fToken != '' && userId != '') {
		// 			this.procesing = true

		// 			return apolloClient
		// 				.mutate({
		// 					mutation: gql`
		// 						mutation($fToken: String!, $userId: String!) {
		// 							userLoginFacebook(fToken: $fToken, userId: $userId) {
		// 								token
		// 								user {
		// 									id
		// 									name
		// 									lastname
		// 									email
		// 									phone {
		// 										countryCode
		// 										national
		// 										international
		// 										type
		// 										validated
		// 									}
		// 									birthdate
		// 									document {
		// 										type
		// 										number
		// 									}
		// 									addressCountry {
		// 										id
		// 										name
		// 									}
		// 									addressCity
		// 									addressStreet
		// 								}
		// 							}
		// 						}
		// 					`,
		// 					variables: {
		// 						fToken,
		// 						userId,
		// 					},
		// 				})
		// 				.then((data) => {
		// 					console.log('loged with facebook', data)
		// 					this.loginSuccess(data.data.userLoginFacebook.token, data.data.userLoginFacebook.user)
		// 				})
		// 				.catch(() => {
		// 					this.loginError = true
		// 					this.procesing = false
		// 				})
		// 		}
		// 	}
		// },

		// loginGoogle(googleUser) {
		// 	consolg.log('loginGoogle', googleUser)

		// 	this.loginError = false
		// 	const gToken = googleUser.getAuthResponse().id_token

		// 	if (!this.loginIn && gToken != '') {
		// 		this.procesing = true

		// 		// return apolloClient
		// 		// 	.mutate({
		// 		// 		mutation: gql`
		// 		// 			mutation($gToken: String!, $publicKey: String!) {
		// 		// 				userLoginGoogle(gToken: $gToken, publicKey: $publicKey) {
		// 		// 					token
		// 		// 					user {
		// 		// 						id
		// 		// 						name
		// 		// 						lastname
		// 		// 						email
		// 		// 						phone {
		// 		// 							countryCode
		// 		// 							national
		// 		// 							international
		// 		// 							type
		// 		// 							validated
		// 		// 						}
		// 		// 						birthdate
		// 		// 						document {
		// 		// 							type
		// 		// 							number
		// 		// 						}
		// 		// 						addressCountry {
		// 		// 							id
		// 		// 							name
		// 		// 						}
		// 		// 						addressCity
		// 		// 						addressStreet
		// 		// 					}
		// 		// 				}
		// 		// 			}
		// 		// 		`,
		// 		// 		variables: {
		// 		// 			gToken,
		// 		// 			publicKey: process.env.VUE_APP_CARCHECK_PK,
		// 		// 		},
		// 		// 	})
		// 		// 	.then((data) => {
		// 		// 		console.log('loged with google', data)
		// 		// 		this.loginSuccess(data.data.userLoginGoogle.token, data.data.userLoginGoogle.user)
		// 		// 	})
		// 		// 	.catch(() => {
		// 		// 		this.loginError = true
		// 		// 		this.procesing = false
		// 		// 	})
		// 	}
		// },

		register() {
			this.registerError = false
			if (
				!this.procesing &&
				this.registerForm.name != "" &&
				this.registerForm.email != "" &&
				this.registerForm.document != "" &&
				this.registerForm.birthdate != "" &&
				this.registerForm.password != ""
			) {
				this.procesing = true
				let dataInput = {
					name: this.registerForm.name,
					lastname: this.registerForm.lastname,
					email: this.registerForm.email,
					birthdate: this.registerForm.birthdate,
					document: this.registerForm.document,
					password: this.registerForm.password,
					passwordConfirm: this.registerForm.passwordConfirm,
					phone: this.registerForm.phone
				}
				return this.$apollo
					.mutate({
						mutation: gql`
							mutation($data: UserSignupInput!) {
								userSignup(data: $data) {
									token
									user {
										id
										name
										lastname
										email
									}
								}
							}
						`,
						variables: {
							data: dataInput
						}
					})
					.then(({ data }) => {
						console.log(data)
						onLogin(this.$apollo.provider.defaultClient, data.userSignup.token, data.userSignup.user).then(
							() => {
								this.loginSuccess(data.userSignup.token, data.userSignup.user)
							}
						)
					})
					.catch((err) => {
						this.parseGQLErrors(err)
						this.registerError = true
						this.procesing = false
					})
			}
		},
		loginSuccess(access_token, logged_user) {
			console.log("loginSuccess", access_token, logged_user)
			this.$store.commit("authSuccess", {
				user: logged_user,
				token: access_token
			})

			this.procesing = false
			if (this.redirectTo) {
				this.$router.push(this.redirectTo)
			} else {
				this.$router.push("/")
			}
		}
	},
	i18n: {
		messages: {
			es: {
				name: "Nombre",
				lastname: "Apellido",
				email: "Email",
				password: "Contraseña",
				passwordConfirm: "Confirmar contraseña",
				phone: "Teléfono",
				button: "Registrarme",
				saving: "Registrando",
				facebook: "Registrarme con Facebook",
				google: "Registrarme con Google",
				alreadyRegistered: "¿Ya tienes cuenta? Ingresar"
			},
			en: {
				name: "Name",
				lastname: "Lastname",
				email: "Email",
				password: "Password",
				passwordConfirm: "Confirm password",
				phone: "Phone",
				button: "Register",
				saving: "Loading",
				facebook: "Register with Facebook",
				google: "Register with Google",
				alreadyRegistered: "Already registered? Login"
			},
			pt: {
				title: "Registrar",
				name: "Nome",
				lastname: "Sobrenome",
				email: "Email",
				password: "Senha",
				passwordConfirm: "Confirmar senha",
				phone: "Telefone",
				button: "Registrar",
				saving: "Salvando",
				facebook: "Registrar com Facebook",
				google: "Registrar com Google",
				alreadyRegistered: "Já tem uma conta? Entrar"
			}
		}
	}
}
</script>

<style scoped>
.alert-conditions {
	background-color: #f3f3f3;
}
.or {
	width: 100%;
	height: 18px;
	position: relative;
}
.or:after {
	content: "o";
	width: 40px;
	font-size: 0.7rem;
	position: absolute;
	left: calc(50% - 20px);
	top: 0px;
	background-color: #fff;
	text-align: center;
	color: #9c9c9c;
	display: flex;
	align-items: center;
	flex-direction: column;
	justify-content: center;
}
.or:before {
	content: "";
	position: absolute;
	left: 0px;
	top: 8px;
	width: 100%;
	border-bottom: 1px solid #cfcfcf;
}

.btn-block {
	width: 100%;
}

.loginBtn--facebook {
	background-color: #4c69ba;
}
.loginBtn--facebook:before {
	background: url("https://s3-us-west-2.amazonaws.com/s.cdpn.io/14082/icon_facebook.png") 6px 6px no-repeat;
}
.loginBtn--facebook:hover,
.loginBtn--facebook:focus {
	color: #fff;
	background-color: #5b7bd5;
}

.loginBtn--google {
	background: #dd4b39;
}
.loginBtn--google:before {
	background: url("https://s3-us-west-2.amazonaws.com/s.cdpn.io/14082/icon_google.png") 6px 6px no-repeat;
}
.loginBtn--google:hover,
.loginBtn--google:focus {
	color: #fff;
	background: #e74b37;
}
</style>
